import request from 'utils/request'

export const getMCAXS531InitRequest = () =>
  request({
    url: '/MCAXS531/init',
    method: 'post',
  })
